import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const SplocaIntroductionBox = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // background: '#f5f9fd',
        px: 2,
      }}
    >
      <Box
        sx={{
          px: { xs: 2, sm: 6 },
          py: { xs: 2, sm: 4 },
          bgcolor: 'white',
          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.18)',
          borderRadius: 3,
          maxWidth: 700,
          width: '100%',
          textAlign: 'center',
            mt:8,
            px:2,
            mb:2
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            color: '#1a237e',
            letterSpacing: '0.08em',
            mb: 2,
            fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' }
          }}
        >
          {t('sploca.heading')}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: '#333',
            fontSize: { xs: '1rem', sm: '1.1rem' },
            textAlign: 'justify'
          }}
        >
          {t('sploca.body')}
        </Typography>
      </Box>
    </Box>
  );
};
